export const CLEAR = '@@nft/CLEAR';
export const UPDATE = '@@nft/UPDATE';

export const SET_DATA = '@@nft/SET_DATA';

export const SET_MAX_SUPPLY = '@@nft/SET_MAX_SUPPLY';
export const SET_TOTAL_SUPPLY = '@@nft/SET_TOTAL_SUPPLY';

export const SET_TIMESTAMP = '@@nft/SET_TIMESTAMP';
export const SET_TIMESTAMP_PRESALE = '@@nft/SET_TIMESTAMP_PRESALE';
export const SET_TIMESTAMP_PRESALE_END = '@@nft/SET_TIMESTAMP_PRESALE_END';
//export const SET_TIMESTAMP_RAFFLE_END = '@@nft/SET_TIMESTAMP_RAFFLE_END';
export const SET_TIMESTAMP_SALE = '@@nft/SET_TIMESTAMP_SALE';

export const SET_PRICE_PRESALE = '@@nft/SET_PRICE_PRESALE';
export const SET_PRICE_SALE = '@@nft/SET_PRICE_SALE';
export const SET_MATADATA = '@@nft/SET_MATADATA';
